import { render, staticRenderFns } from "./BizBusinessinfoProjectModal.vue?vue&type=template&id=1c9a02f1&"
import script from "./BizBusinessinfoProjectModal.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports